/** Prefixed routes section */

/**
 * To add a new view:
 * 1. Define a constant with the route path
 * 2. Add it to the routesMap object below
 * 3. Add it to the ROUTES_INCLUDED array
 * 4. Add it to the routeToViewName mapping object
 * 5. Create a view and add it to App.tsx in routes object
 * 6. (if needed) add it to the featureAccessResolver
 */

// auth
const AUTH_ROUTES_PREFIX = "/auth";
export const LOGIN_ROUTE = `${AUTH_ROUTES_PREFIX}/login`;
export const LOGIN_AS_USER_ROUTE = `${AUTH_ROUTES_PREFIX}/login-as`;
export const PREREGISTER_ROUTE = `${AUTH_ROUTES_PREFIX}/preregister`;
export const SIGNUP_ROUTE = `${AUTH_ROUTES_PREFIX}/signup`;
export const SIGNUP_PLAN_ROUTE = `${AUTH_ROUTES_PREFIX}/signup-plan`;
export const APPSUMO_SIGNUP_ROUTE = `${AUTH_ROUTES_PREFIX}/appsumo-signup`;
export const FORGET_PASSWORD_ROUTE = `${AUTH_ROUTES_PREFIX}/remember`;
export const EMAIL_VERIFICATION_PENDING_ROUTE = `${AUTH_ROUTES_PREFIX}/email-verification-pending`;
export const TRIAL_EMAIL_VERIFICATION_PENDING_ROUTE = `${AUTH_ROUTES_PREFIX}/trial-email-verification-pending`;
export const RESET_PASSWORD_ROUTE = `${AUTH_ROUTES_PREFIX}/reset-password`;
export const GOOGLE_SIGNUP_ROUTE = `${AUTH_ROUTES_PREFIX}/google-signup`;

// blocked
export const LOCKED_ROUTE = "/blocked";

// intelligence
const INTELLIGENCE_ROUTES_PREFIX = "/intelligence";
export const ANALYTICS_ROUTE = `${INTELLIGENCE_ROUTES_PREFIX}/analytics`;
export const OVERVIEW_ROUTE = `${INTELLIGENCE_ROUTES_PREFIX}/overview`;
export const PERFORMANCE_ROUTE = `${INTELLIGENCE_ROUTES_PREFIX}/performance`;
export const BENCHMARK_ROUTE = `${INTELLIGENCE_ROUTES_PREFIX}/benchmark`;
const FULL_REPORTS_ROUTES_PREFIX = "/reports";
export const FULL_REPORTS_LIST_ROUTE = `${INTELLIGENCE_ROUTES_PREFIX}${FULL_REPORTS_ROUTES_PREFIX}/list`;
export const FORM_REPORTS_LIST_ROUTE = `${INTELLIGENCE_ROUTES_PREFIX}${FULL_REPORTS_ROUTES_PREFIX}/form`;
export const SESSION_FORENSICS_ROUTE = `${INTELLIGENCE_ROUTES_PREFIX}/session-forensics`;
export const CONVERSIONS_LIST_ROUTE = `${INTELLIGENCE_ROUTES_PREFIX}/conversions-list`;
export const ALERTS_ROUTE = `${INTELLIGENCE_ROUTES_PREFIX}/alerts`;
export const AI_ASSISTANT_ROUTE = `${INTELLIGENCE_ROUTES_PREFIX}/ai-assistant`;
export const LEADS_ROUTE = `${INTELLIGENCE_ROUTES_PREFIX}/leads`;

// setup
export const SETUP_ROUTES_PREFIX = "/setup";

// firewall
const FIREWALL_ROUTES_PREFIX = "/firewall";

// integration steps
export const SETUP_CENTER_ROUTE = `${SETUP_ROUTES_PREFIX}/center`;

// sensor firewall - offers
const OFFERS_ROUTES_PREFIX = "/offers";
export const OFFERS_LIST_ROUTE = `${SETUP_ROUTES_PREFIX}${FIREWALL_ROUTES_PREFIX}${OFFERS_ROUTES_PREFIX}/list`;

// sensor firewall - traffic-sources
const TRAFFIC_SOURCES_ROUTES_PREFIX = "/traffic-sources";
export const TRAFFIC_SOURCES_LIST_ROUTE = `${SETUP_ROUTES_PREFIX}${FIREWALL_ROUTES_PREFIX}${TRAFFIC_SOURCES_ROUTES_PREFIX}/list`;

// sensor firewall - campaigns
const CAMPAIGNS_ROUTES_PREFIX = "/campaigns";
export const CAMPAIGNS_LIST_ROUTE = `${SETUP_ROUTES_PREFIX}${FIREWALL_ROUTES_PREFIX}${CAMPAIGNS_ROUTES_PREFIX}/list`;

// sensor s2s
const CAMPAIGNS_S2S_ROUTES_PREFIX = "/s2s";
export const CAMPAIGNS_S2S_LIST_ROUTE = `${SETUP_ROUTES_PREFIX}${CAMPAIGNS_S2S_ROUTES_PREFIX}/list`;

// security options
const SECURITY_ROUTES_PREFIX = "/security";
export const APK_SECURITY_ROUTE = `${SETUP_ROUTES_PREFIX}${SECURITY_ROUTES_PREFIX}/apk-security`;
export const IP_SETTINGS_ROUTE = `${SETUP_ROUTES_PREFIX}${SECURITY_ROUTES_PREFIX}/ip-settings`;
export const JS_SETTINGS = `${SETUP_ROUTES_PREFIX}${SECURITY_ROUTES_PREFIX}/javascript-settings`;
export const POSTBACK_SECURITY_ROUTE = `${SETUP_ROUTES_PREFIX}${SECURITY_ROUTES_PREFIX}/postback-security`;
export const DOMAIN_SECURITY_ROUTE = `${SETUP_ROUTES_PREFIX}${SECURITY_ROUTES_PREFIX}/domain-security`;

// integrations
const INTEGRATION_ROUTES_PREFIX = "/integrations";
export const INTEGRATIONS_HOME_ROUTE = INTEGRATION_ROUTES_PREFIX;
const GOOGLE_ROUTES_PREFIX = "/google-ads";
const META_ROUTES_PREFIX = "/meta-ads";
const MICROSOFT_ROUTES_PREFIX = "/microsoft-ads";
const TIKTOK_ROUTES_PREFIX = "/tiktok-ads";
const TABOOLA_ROUTES_PREFIX = "/taboola";
const REDDIT_ROUTES_PREFIX = "/reddit-ads";

export const GOOGLE_SLIM_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${GOOGLE_ROUTES_PREFIX}`;
export const GOOGLE_CONVERSION_ID_MANAGEMENT_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${GOOGLE_ROUTES_PREFIX}/conversion-id-management`;
export const GOOGLE_UNLINKED_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${GOOGLE_ROUTES_PREFIX}/linking-summary`;
export const GOOGLE_LINKING_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${GOOGLE_ROUTES_PREFIX}/linking`;
export const GOOGLE_STEPS_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${GOOGLE_ROUTES_PREFIX}/linking-steps`;
export const GOOGLE_SEARCH_DISPLAY_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${GOOGLE_ROUTES_PREFIX}/search-display`;
export const GOOGLE_SHOPPING_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${GOOGLE_ROUTES_PREFIX}/shopping`;
export const GOOGLE_PMAX_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${GOOGLE_ROUTES_PREFIX}/pmax`;
export const GOOGLE_ACCOUNT_SETTINGS_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${GOOGLE_ROUTES_PREFIX}/account-settings`;
export const GOOGLE_GLOBAL_INTELLIGENCE_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${GOOGLE_ROUTES_PREFIX}/global-intelligence`;

export const META_LINKING_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${META_ROUTES_PREFIX}/linking`;
export const META_OVERVIEW_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${META_ROUTES_PREFIX}/overview`;
export const META_PIXEL_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${META_ROUTES_PREFIX}/pixel`;

export const MICROSOFT_LINKING_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${MICROSOFT_ROUTES_PREFIX}/linking`;
export const MICROSOFT_OVERVIEW_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${MICROSOFT_ROUTES_PREFIX}/overview`;

export const TIKTOK_LINKING_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${TIKTOK_ROUTES_PREFIX}/linking`;
export const TIKTOK_OVERVIEW_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${TIKTOK_ROUTES_PREFIX}/overview`;
export const TIKTOK_PIXEL_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${TIKTOK_ROUTES_PREFIX}/pixel`;

export const TABOOLA_LINKING_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${TABOOLA_ROUTES_PREFIX}/linking`;
export const TABOOLA_OVERVIEW_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${TABOOLA_ROUTES_PREFIX}/overview`;

export const REDDIT_LINKING_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${REDDIT_ROUTES_PREFIX}/linking`;
export const REDDIT_OVERVIEW_ROUTE = `${INTEGRATION_ROUTES_PREFIX}${REDDIT_ROUTES_PREFIX}/overview`;

export const CHANNELS_CENTER_ROUTE = `${INTEGRATION_ROUTES_PREFIX}/channels-center`;

export const HUBSPOT_OVERVIEW_ROUTE = `${INTEGRATION_ROUTES_PREFIX}/hubspot`;

// user administration
export const ACCOUNT_ADMINISTRATION_ROUTES_PREFIX = "/account";
export const USER_ADMINISTRATION_ROUTE = `${ACCOUNT_ADMINISTRATION_ROUTES_PREFIX}/user`;
export const LABEL_ADMINISTRATION_ROUTE = `${ACCOUNT_ADMINISTRATION_ROUTES_PREFIX}/labels`;
export const ACCESS_ADMINISTRATION_ROUTE = `${ACCOUNT_ADMINISTRATION_ROUTES_PREFIX}/access-login-settings`;
export const ACCOUNT_SETTINGS_ROUTE = `${ACCOUNT_ADMINISTRATION_ROUTES_PREFIX}/settings`;
export const ACCOUNT_SUBSCRIPTION_CENTER_ROUTE = `${ACCOUNT_ADMINISTRATION_ROUTES_PREFIX}/subscription-center`;
export const ACCOUNT_REFERRAL_ROUTE = `${ACCOUNT_ADMINISTRATION_ROUTES_PREFIX}/referral`;

/** Top-level routes section */
export const BASE_ROUTE = OVERVIEW_ROUTE;
export const INDEX_ROUTE = "/";
export const EMAIL_VERIFICATION_ROUTE = "/email-verification";
export const ACCOUNT_INACTIVE_ROUTE = "/account-inactive";
export const ACCOUNT_MISSING_ROUTE = "/account-missing";
export const LICENSE_DEACTIVATED_ROUTE = "/license-deactivated";
export const SELECT_ROLE_ROUTE = "/role";
export const LOGOUT_ROUTE = "/logout";
export const DEVELOPERS_SETTING_SCREEN = "/developers-settings";
export const FORBIDDEN_ROUTE = "/403-forbidden";
export const PERFORMANCE_UNSUBSCRIBE_ROUTE = "/performance/unsubscribe";

/**
 * All components located on these paths
 * will have navigation sidebar.
 */
export const ROUTES_INCLUDED = Object.freeze([
  ACCOUNT_SETTINGS_ROUTE,
  DEVELOPERS_SETTING_SCREEN,
  OVERVIEW_ROUTE,
  INTEGRATIONS_HOME_ROUTE,
  ANALYTICS_ROUTE,
  PERFORMANCE_ROUTE,
  BENCHMARK_ROUTE,
  SESSION_FORENSICS_ROUTE,
  CONVERSIONS_LIST_ROUTE,
  FULL_REPORTS_LIST_ROUTE,
  FORM_REPORTS_LIST_ROUTE,
  OFFERS_LIST_ROUTE,
  TRAFFIC_SOURCES_LIST_ROUTE,
  CAMPAIGNS_S2S_LIST_ROUTE,
  SETUP_CENTER_ROUTE,
  AI_ASSISTANT_ROUTE,
  CAMPAIGNS_LIST_ROUTE,
  APK_SECURITY_ROUTE,
  IP_SETTINGS_ROUTE,
  JS_SETTINGS,
  POSTBACK_SECURITY_ROUTE,
  DOMAIN_SECURITY_ROUTE,
  USER_ADMINISTRATION_ROUTE,
  LABEL_ADMINISTRATION_ROUTE,
  ACCESS_ADMINISTRATION_ROUTE,
  ACCOUNT_SUBSCRIPTION_CENTER_ROUTE,
  ACCOUNT_REFERRAL_ROUTE,
  GOOGLE_SLIM_ROUTE,
  GOOGLE_CONVERSION_ID_MANAGEMENT_ROUTE,
  GOOGLE_UNLINKED_ROUTE,
  GOOGLE_LINKING_ROUTE,
  GOOGLE_STEPS_ROUTE,
  GOOGLE_SEARCH_DISPLAY_ROUTE,
  GOOGLE_SHOPPING_ROUTE,
  GOOGLE_PMAX_ROUTE,
  GOOGLE_ACCOUNT_SETTINGS_ROUTE,
  GOOGLE_GLOBAL_INTELLIGENCE_ROUTE,
  ALERTS_ROUTE,
  META_LINKING_ROUTE,
  META_OVERVIEW_ROUTE,
  META_PIXEL_ROUTE,
  MICROSOFT_LINKING_ROUTE,
  MICROSOFT_OVERVIEW_ROUTE,
  TIKTOK_LINKING_ROUTE,
  TIKTOK_OVERVIEW_ROUTE,
  TIKTOK_PIXEL_ROUTE,
  TABOOLA_LINKING_ROUTE,
  TABOOLA_OVERVIEW_ROUTE,
  REDDIT_LINKING_ROUTE,
  REDDIT_OVERVIEW_ROUTE,
  HUBSPOT_OVERVIEW_ROUTE,
  CHANNELS_CENTER_ROUTE,
  TIKTOK_ROUTES_PREFIX,
  LEADS_ROUTE,
]);

/**
 * Utility that makes work with routes easier
 */
export const routesMap = Object.freeze({
  index: {
    path: INDEX_ROUTE,
    get pathWithSearch(): string {
      return INDEX_ROUTE.concat(window.location.search);
    },
    wildcardPath: `${INDEX_ROUTE}*`,
  },
  base: {
    path: BASE_ROUTE,
    get pathWithSearch(): string {
      return BASE_ROUTE.concat(window.location.search);
    },
    wildcardPath: `${BASE_ROUTE}/*`,
  },
  emailVerification: {
    path: EMAIL_VERIFICATION_ROUTE,
    get pathWithSearch(): string {
      return EMAIL_VERIFICATION_ROUTE.concat(window.location.search);
    },
    wildcardPath: `${EMAIL_VERIFICATION_ROUTE}/*`,
  },
  accountInactive: {
    path: ACCOUNT_INACTIVE_ROUTE,
    get pathWithSearch(): string {
      return ACCOUNT_INACTIVE_ROUTE.concat(window.location.search);
    },
    wildcardPath: `${ACCOUNT_INACTIVE_ROUTE}/*`,
  },
  licenseDeactivated: {
    path: LICENSE_DEACTIVATED_ROUTE,
    get pathWithSearch(): string {
      return LICENSE_DEACTIVATED_ROUTE.concat(window.location.search);
    },
    wildcardPath: `${LICENSE_DEACTIVATED_ROUTE}/*`,
  },
  accountMissing: {
    path: ACCOUNT_MISSING_ROUTE,
    get pathWithSearch(): string {
      return ACCOUNT_MISSING_ROUTE.concat(window.location.search);
    },
    wildcardPath: `${ACCOUNT_MISSING_ROUTE}/*`,
  },
  forbidden: {
    path: FORBIDDEN_ROUTE,
    get pathWithSearch(): string {
      return FORBIDDEN_ROUTE.concat(window.location.search);
    },
    wildcardPath: `${FORBIDDEN_ROUTE}/*`,
  },
  role: {
    path: SELECT_ROLE_ROUTE,
    get pathWithSearch(): string {
      return SELECT_ROLE_ROUTE.concat(window.location.search);
    },
    wildcardPath: `${SELECT_ROLE_ROUTE}/*`,
  },
  logout: {
    path: LOGOUT_ROUTE,
    get pathWithSearch(): string {
      return LOGOUT_ROUTE.concat(window.location.search);
    },
    wildcardPath: `${LOGOUT_ROUTE}/*`,
  },
  developersSettings: {
    path: DEVELOPERS_SETTING_SCREEN,
    get pathWithSearch(): string {
      return DEVELOPERS_SETTING_SCREEN.concat(window.location.search);
    },
    wildcardPath: `${DEVELOPERS_SETTING_SCREEN}/*`,
  },
  unsubscribe: {
    path: PERFORMANCE_UNSUBSCRIBE_ROUTE,
    get pathWithSearch(): string {
      return PERFORMANCE_UNSUBSCRIBE_ROUTE.concat(window.location.search);
    },
    wildcardPath: `${PERFORMANCE_UNSUBSCRIBE_ROUTE}/*`,
  },
  blocked: {
    path: LOCKED_ROUTE,
    get pathWithSearch(): string {
      return LOCKED_ROUTE.concat(window.location.search);
    },
  },
  auth: {
    login: {
      path: LOGIN_ROUTE,
      get pathWithSearch(): string {
        return LOGIN_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${LOGIN_ROUTE}/*`,
    },
    loginAsUser: {
      path: LOGIN_AS_USER_ROUTE,
      get pathWithSearch(): string {
        return LOGIN_AS_USER_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${LOGIN_AS_USER_ROUTE}/*`,
    },
    preregister: {
      path: PREREGISTER_ROUTE,
      get pathWithSearch(): string {
        return PREREGISTER_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${PREREGISTER_ROUTE}/*`,
    },
    signup: {
      path: SIGNUP_ROUTE,
      get pathWithSearch(): string {
        return SIGNUP_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${SIGNUP_ROUTE}/*`,
    },
    signupPlan: {
      path: SIGNUP_PLAN_ROUTE,
      get pathWithSearch(): string {
        return SIGNUP_PLAN_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${SIGNUP_PLAN_ROUTE}/*`,
    },
    appsumoSignup: {
      path: APPSUMO_SIGNUP_ROUTE,
      get pathWithSearch(): string {
        return APPSUMO_SIGNUP_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${APPSUMO_SIGNUP_ROUTE}/*`,
    },
    forgotPassword: {
      path: FORGET_PASSWORD_ROUTE,
      get pathWithSearch(): string {
        return FORGET_PASSWORD_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${FORGET_PASSWORD_ROUTE}/*`,
    },
    emailVerificationPending: {
      path: EMAIL_VERIFICATION_PENDING_ROUTE,
      get pathWithSearch(): string {
        return EMAIL_VERIFICATION_PENDING_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${EMAIL_VERIFICATION_PENDING_ROUTE}/*`,
    },
    trialEmailVerificationPending: {
      path: TRIAL_EMAIL_VERIFICATION_PENDING_ROUTE,
      get pathWithSearch(): string {
        return TRIAL_EMAIL_VERIFICATION_PENDING_ROUTE.concat(
          window.location.search
        );
      },
      wildcardPath: `${TRIAL_EMAIL_VERIFICATION_PENDING_ROUTE}/*`,
    },
    resetPassword: {
      path: RESET_PASSWORD_ROUTE,
      get pathWithSearch(): string {
        return RESET_PASSWORD_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${RESET_PASSWORD_ROUTE}/*`,
    },
    googleSignup: {
      path: GOOGLE_SIGNUP_ROUTE,
      get pathWithSearch(): string {
        return GOOGLE_SIGNUP_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${GOOGLE_SIGNUP_ROUTE}/*`,
    },
  },
  intelligence: {
    overview: {
      path: OVERVIEW_ROUTE,
      get pathWithSearch(): string {
        return OVERVIEW_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${OVERVIEW_ROUTE}/*`,
    },
    analytics: {
      path: ANALYTICS_ROUTE,
      get pathWithSearch(): string {
        return ANALYTICS_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${ANALYTICS_ROUTE}/*`,
    },
    performance: {
      path: PERFORMANCE_ROUTE,
      get pathWithSearch(): string {
        return PERFORMANCE_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${PERFORMANCE_ROUTE}/*`,
    },
    benchmark: {
      path: BENCHMARK_ROUTE,
      get pathWithSearch(): string {
        return BENCHMARK_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${BENCHMARK_ROUTE}/*`,
    },
    reports: {
      list: {
        path: FULL_REPORTS_LIST_ROUTE,
        get pathWithSearch(): string {
          return FULL_REPORTS_LIST_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${FULL_REPORTS_LIST_ROUTE}/*`,
      },
      form: {
        path: FORM_REPORTS_LIST_ROUTE,
        get pathWithSearch(): string {
          return FORM_REPORTS_LIST_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${FORM_REPORTS_LIST_ROUTE}/*`,
      },
    },
    forensics: {
      path: SESSION_FORENSICS_ROUTE,
      get pathWithSearch(): string {
        return SESSION_FORENSICS_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${SESSION_FORENSICS_ROUTE}/*`,
    },
    conversions: {
      path: CONVERSIONS_LIST_ROUTE,
      get pathWithSearch(): string {
        return CONVERSIONS_LIST_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${CONVERSIONS_LIST_ROUTE}/*`,
    },
    alerts: {
      path: ALERTS_ROUTE,
      get pathWithSearch(): string {
        return ALERTS_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${ALERTS_ROUTE}/*`,
    },
    aiAssistant: {
      path: AI_ASSISTANT_ROUTE,
      get pathWithSearch(): string {
        return AI_ASSISTANT_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${AI_ASSISTANT_ROUTE}/*`,
    },
    leads: {
      path: LEADS_ROUTE,
      get pathWithSearch(): string {
        return LEADS_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${LEADS_ROUTE}/*`,
    },
  },
  setup: {
    offer: {
      list: {
        path: OFFERS_LIST_ROUTE,
        get pathWithSearch(): string {
          return OFFERS_LIST_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${OFFERS_LIST_ROUTE}/*`,
      },
    },
    trafficSource: {
      list: {
        path: TRAFFIC_SOURCES_LIST_ROUTE,
        get pathWithSearch(): string {
          return TRAFFIC_SOURCES_LIST_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${TRAFFIC_SOURCES_LIST_ROUTE}/*`,
      },
    },
    setupCenter: {
      path: SETUP_CENTER_ROUTE,
      get pathWithSearch(): string {
        return SETUP_CENTER_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${SETUP_CENTER_ROUTE}/*`,
    },
    sensorFirewall: {
      list: {
        path: CAMPAIGNS_LIST_ROUTE,
        get pathWithSearch(): string {
          return CAMPAIGNS_LIST_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${CAMPAIGNS_LIST_ROUTE}/*`,
      },
    },
    sensorS2S: {
      list: {
        path: CAMPAIGNS_S2S_LIST_ROUTE,
        get pathWithSearch(): string {
          return CAMPAIGNS_S2S_LIST_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${CAMPAIGNS_S2S_LIST_ROUTE}/*`,
      },
    },
    security: {
      apkSecurity: {
        path: APK_SECURITY_ROUTE,
        get pathWithSearch(): string {
          return APK_SECURITY_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${APK_SECURITY_ROUTE}/*`,
      },
      ipSettings: {
        path: IP_SETTINGS_ROUTE,
        get pathWithSearch(): string {
          return IP_SETTINGS_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${IP_SETTINGS_ROUTE}/*`,
      },
      jsSettings: {
        path: JS_SETTINGS,
        get pathWithSearch(): string {
          return JS_SETTINGS.concat(window.location.search);
        },
        wildcardPath: `${JS_SETTINGS}/*`,
      },
      postbackSecurity: {
        path: POSTBACK_SECURITY_ROUTE,
        get pathWithSearch(): string {
          return POSTBACK_SECURITY_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${POSTBACK_SECURITY_ROUTE}/*`,
      },
      domainSecurity: {
        path: DOMAIN_SECURITY_ROUTE,
        get pathWithSearch(): string {
          return DOMAIN_SECURITY_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${DOMAIN_SECURITY_ROUTE}/*`,
      },
    },
  },
  integration: {
    home: {
      path: INTEGRATIONS_HOME_ROUTE,
      get pathWithSearch(): string {
        return INTEGRATIONS_HOME_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${INTEGRATIONS_HOME_ROUTE}/*`,
    },
    google: {
      unlinked: {
        path: GOOGLE_UNLINKED_ROUTE,
        get pathWithSearch(): string {
          return GOOGLE_UNLINKED_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${GOOGLE_UNLINKED_ROUTE}/*`,
      },
      linking: {
        path: GOOGLE_LINKING_ROUTE,
        get pathWithSearch(): string {
          return GOOGLE_LINKING_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${GOOGLE_LINKING_ROUTE}/*`,
      },
      slim: {
        path: GOOGLE_SLIM_ROUTE,
        get pathWithSearch(): string {
          return GOOGLE_SLIM_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${GOOGLE_SLIM_ROUTE}/*`,
      },
      pixel: {
        path: GOOGLE_CONVERSION_ID_MANAGEMENT_ROUTE,
        get pathWithSearch(): string {
          return GOOGLE_CONVERSION_ID_MANAGEMENT_ROUTE.concat(
            window.location.search
          );
        },
        wildcardPath: `${GOOGLE_CONVERSION_ID_MANAGEMENT_ROUTE}/*`,
      },
      steps: {
        path: GOOGLE_STEPS_ROUTE,
        get pathWithSearch(): string {
          return GOOGLE_STEPS_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${GOOGLE_STEPS_ROUTE}/*`,
      },
      searchdisplay: {
        path: GOOGLE_SEARCH_DISPLAY_ROUTE,
        get pathWithSearch(): string {
          return GOOGLE_SEARCH_DISPLAY_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${GOOGLE_SEARCH_DISPLAY_ROUTE}/*`,
      },
      shopping: {
        path: GOOGLE_SHOPPING_ROUTE,
        get pathWithSearch(): string {
          return GOOGLE_SHOPPING_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${GOOGLE_SHOPPING_ROUTE}/*`,
      },
      pmax: {
        path: GOOGLE_PMAX_ROUTE,
        get pathWithSearch(): string {
          return GOOGLE_PMAX_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${GOOGLE_PMAX_ROUTE}/*`,
      },
      accountSettings: {
        path: GOOGLE_ACCOUNT_SETTINGS_ROUTE,
        get pathWithSearch(): string {
          return GOOGLE_ACCOUNT_SETTINGS_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${GOOGLE_ACCOUNT_SETTINGS_ROUTE}/*`,
      },
      globalIntelligence: {
        path: GOOGLE_GLOBAL_INTELLIGENCE_ROUTE,
        get pathWithSearch(): string {
          return GOOGLE_GLOBAL_INTELLIGENCE_ROUTE.concat(
            window.location.search
          );
        },
        wildcardPath: `${GOOGLE_GLOBAL_INTELLIGENCE_ROUTE}/*`,
      },
    },
    meta: {
      linking: {
        path: META_LINKING_ROUTE,
        get pathWithSearch(): string {
          return META_LINKING_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${META_LINKING_ROUTE}/*`,
      },
      overview: {
        path: META_OVERVIEW_ROUTE,
        get pathWithSearch(): string {
          return META_OVERVIEW_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${META_OVERVIEW_ROUTE}/*`,
      },
      pixel: {
        path: META_PIXEL_ROUTE,
        get pathWithSearch(): string {
          return META_PIXEL_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${META_PIXEL_ROUTE}/*`,
      },
    },
    microsoft: {
      linking: {
        path: MICROSOFT_LINKING_ROUTE,
        get pathWithSearch(): string {
          return MICROSOFT_LINKING_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${MICROSOFT_LINKING_ROUTE}/*`,
      },
      overview: {
        path: MICROSOFT_OVERVIEW_ROUTE,
        get pathWithSearch(): string {
          return MICROSOFT_OVERVIEW_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${MICROSOFT_OVERVIEW_ROUTE}/*`,
      },
    },
    tiktok: {
      linking: {
        path: TIKTOK_LINKING_ROUTE,
        get pathWithSearch(): string {
          return TIKTOK_LINKING_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${TIKTOK_LINKING_ROUTE}/*`,
      },
      overview: {
        path: TIKTOK_OVERVIEW_ROUTE,
        get pathWithSearch(): string {
          return TIKTOK_OVERVIEW_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${TIKTOK_OVERVIEW_ROUTE}/*`,
      },
      pixel: {
        path: TIKTOK_PIXEL_ROUTE,
        get pathWithSearch(): string {
          return TIKTOK_PIXEL_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${TIKTOK_PIXEL_ROUTE}/*`,
      },
    },
    taboola: {
      linking: {
        path: TABOOLA_LINKING_ROUTE,
        get pathWithSearch(): string {
          return TABOOLA_LINKING_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${TABOOLA_LINKING_ROUTE}/*`,
      },
      overview: {
        path: TABOOLA_OVERVIEW_ROUTE,
        get pathWithSearch(): string {
          return TABOOLA_OVERVIEW_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${TABOOLA_OVERVIEW_ROUTE}/*`,
      },
    },
    reddit: {
      linking: {
        path: REDDIT_LINKING_ROUTE,
        get pathWithSearch(): string {
          return REDDIT_LINKING_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${REDDIT_LINKING_ROUTE}/*`,
      },
      overview: {
        path: REDDIT_OVERVIEW_ROUTE,
        get pathWithSearch(): string {
          return REDDIT_OVERVIEW_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${REDDIT_OVERVIEW_ROUTE}/*`,
      },
    },
    hubspot: {
      overview: {
        path: HUBSPOT_OVERVIEW_ROUTE,
        get pathWithSearch(): string {
          return HUBSPOT_OVERVIEW_ROUTE.concat(window.location.search);
        },
        wildcardPath: `${HUBSPOT_OVERVIEW_ROUTE}/*`,
      },
    },
    channelsCenter: {
      path: CHANNELS_CENTER_ROUTE,
      get pathWithSearch(): string {
        return CHANNELS_CENTER_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${CHANNELS_CENTER_ROUTE}/*`,
    },
  },
  account: {
    users: {
      path: USER_ADMINISTRATION_ROUTE,
      get pathWithSearch(): string {
        return USER_ADMINISTRATION_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${USER_ADMINISTRATION_ROUTE}/*`,
    },
    labels: {
      path: LABEL_ADMINISTRATION_ROUTE,
      get pathWithSearch(): string {
        return LABEL_ADMINISTRATION_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${LABEL_ADMINISTRATION_ROUTE}/*`,
    },
    access: {
      path: ACCESS_ADMINISTRATION_ROUTE,
      get pathWithSearch(): string {
        return ACCESS_ADMINISTRATION_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${ACCESS_ADMINISTRATION_ROUTE}/*`,
    },
    settings: {
      path: ACCOUNT_SETTINGS_ROUTE,
      get pathWithSearch(): string {
        return ACCOUNT_SETTINGS_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${ACCOUNT_SETTINGS_ROUTE}/*`,
    },
    subscriptionCenter: {
      path: ACCOUNT_SUBSCRIPTION_CENTER_ROUTE,
      get pathWithSearch(): string {
        return ACCOUNT_SUBSCRIPTION_CENTER_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${ACCOUNT_SUBSCRIPTION_CENTER_ROUTE}/*`,
    },
    referral: {
      path: ACCOUNT_REFERRAL_ROUTE,
      get pathWithSearch(): string {
        return ACCOUNT_REFERRAL_ROUTE.concat(window.location.search);
      },
      wildcardPath: `${ACCOUNT_REFERRAL_ROUTE}/*`,
    },
  },
});

// Feature Names
export const VIEWS = Object.freeze({
  OVERVIEW: "home",
  ANALYTICS: "analytics",
  PERFORMANCE: "performance",
  BENCHMARK: "benchmark",
  REPORTS: "reports",
  FORENSICS: "forensics",
  CONVERSIONS: "conversions",
  ALERTS: "alerts",
  GOOGLE: Object.freeze({
    MAIN: "google_ppc",
    SEARCH_DISPLAY: "search_display",
    SHOPPING: "shopping",
    PMAX_DEMANDGEN: "pmax",
    ACCOUNT_SETTINGS: "account_settings",
    GLOBAL_INTELLIGENCE: "gads_global_intelligence",
  }),
  META: "facebook_ads",
  META_INTEGRATION: "facebook_ads_integration",
  MICROSOFT: "microsoft_ads",
  MICROSOFT_INTEGRATION: "microsoft_ads_integration",
  TIKTOK: "tiktok_ads",
  TIKTOK_INTEGRATION: "tiktok_integration",
  TABOOLA: "taboola",
  TABOOLA_INTEGRATION: "taboola_integration",
  REDDIT: "reddit",
  REDDIT_INTEGRATION: "reddit_integration",
  HUBSPOT: "hubspot",
  SENSOR_JS: "sensor_js",
  SETUP_CENTER: "setup_center",
  CHANNELS_CENTER: "channels_center",
  INTEGRATIONS_HOME: "integrations_home",
  AI_ASSISTANT: "ai_assistant",
  LEADS: "leads",
  SENSOR_FIREWALL: {
    CAMPAIGNS: "firewall_campaigns",
    OFFERS: "firewall_offers",
    TRAFFIC_SOURCES: "firewall_traffic_sources",
    S2S: "sensor_s2s",
  },
  SECURITY: {
    APK: "apk",
    IP_SETTINGS: "ip_settings",
    JS_SETTINGS: "js_settings",
    POSTBACK: "postback",
    DOMAIN_EXCLUSIONS: "domain_exclusions",
  },
  ROLE: "role",
  ACCOUNT: {
    USERS: "users",
    SETTINGS: "settings",
    LABELS: "labels",
    ACCESS_SETTINGS: "access",
    SUBSCRIPTION_CENTER: "plans",
    REFERRAL: "referral",
    DEVELOPERS_SETTINGS: "developers_settings",
  },
});

export const routeToViewName = {
  [routesMap.intelligence.analytics.path]: VIEWS.ANALYTICS,
  [routesMap.intelligence.overview.path]: VIEWS.OVERVIEW,
  [routesMap.intelligence.performance.path]: VIEWS.PERFORMANCE,
  [routesMap.intelligence.benchmark.path]: VIEWS.BENCHMARK,
  [routesMap.intelligence.reports.list.path]: VIEWS.REPORTS,
  [routesMap.intelligence.reports.form.path]: VIEWS.REPORTS,
  [routesMap.intelligence.forensics.path]: VIEWS.FORENSICS,
  [routesMap.intelligence.conversions.path]: VIEWS.CONVERSIONS,
  [routesMap.intelligence.alerts.path]: VIEWS.ALERTS,
  [routesMap.integration.google.unlinked.path]: VIEWS.GOOGLE.MAIN,
  [routesMap.integration.google.linking.path]: VIEWS.GOOGLE.MAIN,
  [routesMap.integration.google.slim.path]: VIEWS.GOOGLE.MAIN,
  [routesMap.integration.google.steps.path]: VIEWS.GOOGLE.MAIN,
  [routesMap.integration.google.pixel.path]: VIEWS.GOOGLE.MAIN,
  [routesMap.integration.google.searchdisplay.path]:
    VIEWS.GOOGLE.SEARCH_DISPLAY,
  [routesMap.integration.google.shopping.path]: VIEWS.GOOGLE.SHOPPING,
  [routesMap.integration.google.pmax.path]: VIEWS.GOOGLE.PMAX_DEMANDGEN,
  [routesMap.integration.google.accountSettings.path]:
    VIEWS.GOOGLE.ACCOUNT_SETTINGS,
  [routesMap.integration.google.globalIntelligence.path]:
    VIEWS.GOOGLE.GLOBAL_INTELLIGENCE,
  [routesMap.integration.meta.linking.path]: VIEWS.META_INTEGRATION,
  [routesMap.integration.meta.pixel.path]: VIEWS.META_INTEGRATION,
  [routesMap.integration.meta.overview.path]: VIEWS.META,
  [routesMap.integration.microsoft.linking.path]: VIEWS.MICROSOFT_INTEGRATION,
  [routesMap.integration.microsoft.overview.path]: VIEWS.MICROSOFT,
  [routesMap.integration.tiktok.linking.path]: VIEWS.TIKTOK_INTEGRATION,
  [routesMap.integration.tiktok.overview.path]: VIEWS.TIKTOK,
  [routesMap.integration.tiktok.pixel.path]: VIEWS.TIKTOK_INTEGRATION,
  [routesMap.integration.taboola.linking.path]: VIEWS.TABOOLA_INTEGRATION,
  [routesMap.integration.taboola.overview.path]: VIEWS.TABOOLA,
  [routesMap.integration.reddit.linking.path]: VIEWS.REDDIT_INTEGRATION,
  [routesMap.integration.reddit.overview.path]: VIEWS.REDDIT,
  [routesMap.integration.hubspot.overview.path]: VIEWS.HUBSPOT,
  [routesMap.integration.home.path]: VIEWS.INTEGRATIONS_HOME,
  [routesMap.integration.channelsCenter.path]: VIEWS.CHANNELS_CENTER,
  [routesMap.setup.setupCenter.path]: VIEWS.SETUP_CENTER,
  [routesMap.intelligence.aiAssistant.path]: VIEWS.AI_ASSISTANT,
  [routesMap.intelligence.leads.path]: VIEWS.LEADS,
  [routesMap.setup.sensorFirewall.list.path]: VIEWS.SENSOR_FIREWALL.CAMPAIGNS,
  [routesMap.setup.trafficSource.list.path]:
    VIEWS.SENSOR_FIREWALL.TRAFFIC_SOURCES,
  [routesMap.setup.offer.list.path]: VIEWS.SENSOR_FIREWALL.OFFERS,
  [routesMap.setup.sensorS2S.list.path]: VIEWS.SENSOR_FIREWALL.S2S,
  [routesMap.setup.security.apkSecurity.path]: VIEWS.SECURITY.APK,
  [routesMap.setup.security.ipSettings.path]: VIEWS.SECURITY.IP_SETTINGS,
  [routesMap.setup.security.jsSettings.path]: VIEWS.SECURITY.JS_SETTINGS,
  [routesMap.setup.security.postbackSecurity.path]: VIEWS.SECURITY.POSTBACK,
  [routesMap.setup.security.domainSecurity.path]:
    VIEWS.SECURITY.DOMAIN_EXCLUSIONS,
  [routesMap.account.users.path]: VIEWS.ACCOUNT.USERS,
  [routesMap.account.settings.path]: VIEWS.ACCOUNT.SETTINGS,
  [routesMap.account.labels.path]: VIEWS.ACCOUNT.LABELS,
  [routesMap.account.access.path]: VIEWS.ACCOUNT.ACCESS_SETTINGS,
  [routesMap.account.subscriptionCenter.path]:
    VIEWS.ACCOUNT.SUBSCRIPTION_CENTER,
  [routesMap.account.referral.path]: VIEWS.ACCOUNT.REFERRAL,
  [routesMap.developersSettings.path]: VIEWS.ACCOUNT.DEVELOPERS_SETTINGS,
  [routesMap.role.path]: VIEWS.ROLE,
};
